// React and related imports
import React from 'react';

// Icons
import {
  HiOutlineDocumentText,
  HiOutlineMicrophone,
  HiOutlinePhotograph,
  HiOutlineVideoCamera,
} from 'react-icons/hi';

// Enums
import { MediaTypes } from '../../common/enums/MediaTypes';

// Utils
import { localizeMediaType } from '../../utils/localizeMediaType';

// i18n hooks
import { useTranslation } from 'react-i18next';

interface MediaGalleryToolbarProps {
  filter: 'all' | MediaTypes;
  onFilterChange: (filter: 'all' | MediaTypes) => void;
  totalItems: number;
}

export const MediaGalleryToolbar: React.FC<MediaGalleryToolbarProps> = ({
  filter,
  onFilterChange,
  totalItems,
}) => {
  const { t } = useTranslation();

  const FilterButton = ({
    type,
    label,
    icon,
  }: {
    type: 'all' | MediaTypes;
    label: string;
    icon?: React.ReactNode;
  }) => (
    <button
      onClick={() => onFilterChange(type)}
      className={`flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium transition-all duration-200 ${
        filter === type
          ? 'bg-gray-900 text-white'
          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
      } `}
    >
      {icon}
      {label}
    </button>
  );

  return (
    <div className="flex items-center justify-between px-2">
      <div className="flex items-center gap-2">
        <FilterButton type="all" label={`${t('content.all')} ${totalItems}`} />
        <FilterButton
          type={MediaTypes.IMAGE}
          label={localizeMediaType(MediaTypes.IMAGE)}
          icon={<HiOutlinePhotograph className="h-4 w-4" />}
        />
        <FilterButton
          type={MediaTypes.VIDEO}
          label={localizeMediaType(MediaTypes.VIDEO)}
          icon={<HiOutlineVideoCamera className="h-4 w-4" />}
        />
        <FilterButton
          type={MediaTypes.SOUND}
          label={localizeMediaType(MediaTypes.SOUND)}
          icon={<HiOutlineMicrophone className="h-4 w-4" />}
        />
        <FilterButton
          type={MediaTypes.DOCUMENT}
          label={localizeMediaType(MediaTypes.DOCUMENT)}
          icon={<HiOutlineDocumentText className="h-4 w-4" />}
        />
      </div>
    </div>
  );
};
